// extracted by mini-css-extract-plugin
export var box = "_84-1";
export var checked = "_84-2";
export var descriptionSpacer = "_84-9";
export var disabled = "_84-3";
export var icon = "_84-6";
export var input = "_84-0";
export var labelSpacer = "_84-8";
export var medium = "_84-5";
export var small = "_84-4";
export var text = "_84-7";